<template>
  <nav class="navbar navbar-expand-lg p-0">
    <div class="container h-100">
      <span class="flex-1"></span>
      <a href="https://www.beweegbuddy.be" target="_blank" class="navbar-brand mx-auto" v-hover="onHoverOverLogo">BEWEEGBUDDY</a>
      <button @click="toggleDropdown" class="navbar-toggler" data-toggle="collapse" data-target="#navbarMenu"
              aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation" type="button">
        <span class="navbar-toggler-icon"><MobileCollapseLogo/></span>
      </button>

      <ul class="dropdown-menu" v-if="dropdownOpen">
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/login" class="nav-link">Aanmelden</router-link>
        </li>
        <li class="dropdown-item" @click="closeDropdown">
          <router-link to="/register" class="nav-link">Registreren</router-link>
        </li>
      </ul>

      <div id="navbarMenu" class="collapse navbar-collapse h-100">
        <ul class="navbar-nav ml-auto h-100">
          <li class="nav-item">
            <router-link to="/login" class="nav-link">Aanmelden</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/register" class="nav-link">Registreren</router-link>
          </li>
        </ul>
      </div>
    </div>
    <HoverInfo :show="hoveringOverLogo" :content="'Ga terug naar de website'"></HoverInfo>
  </nav>
</template>

<script>
import NavIcons from "@/mixins/NavIcons";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "LoginNav",
  components: {HoverInfo},
  mixins: [ NavIcons ],
  props: {
    isAuthenticated: Boolean
  },
  data()
  {
    return {
      dropdownOpen: false,
      hoveringOverLogo: false,
    }
  },
  methods: {
    toggleDropdown()
    {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown()
    {
      this.dropdownOpen = false;
    },
    onHoverOverLogo(state) {
      this.hoveringOverLogo = state;
    }
  }
}
</script>

<style lang="scss" scoped>
nav
{
  height: 75px;
  background-color: $primary-blue;

  @media (min-width: 992px)
  {
    overflow-x: auto;
  }
}

.flex-1
{
  @media (min-width: 992px)
  {
    flex: 1;
  }
}

.navbar-expand-lg .navbar-collapse
{
  @media (min-width: 992px)
  {
    flex-basis: 0;
  }
}
</style>